import removeMd from 'remove-markdown';
import { decode } from 'html-entities';

export function removeMarkdown(mdText: string): string {
  const text = removeMd(mdText);
  return decode(text);
}
